import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { useTranslation } from 'react-i18next';
import { playSound } from '../utils/soundPlayer';
import './LeaderboardArchiveListPage.css';

const LeaderboardArchiveListPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [archives, setArchives] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadArchives = async () => {
      try {
        const q = query(collection(db, 'leaderboardArchives'), orderBy('createdAt', 'desc'));
        const snapshot = await getDocs(q);
        const archiveList = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setArchives(archiveList);
      } catch (error) {
        console.error('Error loading archives:', error);
      } finally {
        setLoading(false);
      }
    };

    loadArchives();
  }, []);

  if (loading) {
    return (
      <div className="leaderboard-archive-list-page">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>{t('leaderboardArchives.loadingArchives')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="leaderboard-archive-list-page">
      <h1>{t('leaderboardArchives.title')}</h1>
      
      {archives.length === 0 ? (
        <div className="empty-archives">
          <p>{t('leaderboardArchives.noArchives')}</p>
          <p className="empty-subtitle">{t('leaderboardArchives.noArchivesSubtitle')}</p>
        </div>
      ) : (
        <div className="archives-grid">
          {archives.map((archive) => (
            <div 
              key={archive.id} 
              className="archive-card"
              onClick={() => {
                playSound('select');
                navigate(`/leaderboard-archive/${archive.id}`);
              }}
            >
              <div className="archive-card-header">
                <h3>{archive.name}</h3>
              </div>
              <div className="archive-card-body">
                <div className="archive-stat">
                  <span className="stat-label">{t('leaderboardArchives.totalDuelists')}</span>
                  <span className="stat-value">{archive.totalDuelists}</span>
                </div>
                {archive.leaderboard && archive.leaderboard.length > 0 && (
                  <div className="archive-champion">
                    <span className="champion-label">{t('leaderboardArchives.blueObeliskTop4')}</span>
                    <div className="champion-list">
                      {archive.leaderboard.slice(0, 4).map((duelist, index) => (
                        <div key={duelist.userId} className="champion-info">
                          <span className="champion-rank">#{index + 1}</span>
                          <img 
                            src={duelist.profilePicture || '/default-avatar.png'} 
                            alt={`Rank ${index + 1}`}
                            className="champion-avatar"
                          />
                          <span className="champion-name">{duelist.pseudo}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
              <div className="archive-card-footer">
                <button className="view-archive-btn">
                  {t('leaderboardArchives.viewArchive')}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      <button
        className="back-button"
        onClick={() => {
          playSound('return');
          navigate('/tool');
        }}
      >
        {t('leaderboardArchives.back')}
      </button>
    </div>
  );
};

export default LeaderboardArchiveListPage;
